import { Navigate, Outlet, useLocation } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { isClusterPortalRole } from "@/shared/utils/clusterPortalRole.util";
import { invalidateClientSession } from "@/shared/utils/authSession.util";
import { useAuth } from "@/hooks/useAuth";
import { RouteFallback } from "@/routes/RouteFallback";
import { isCompanyAppPortalRole } from "@/shared/utils/expoVisitorRole.util";

type DecodedToken = {
  id: string;
  email: string;
  role: string;
  exp: number;
  iat: number;
};

export function EcosystemHeadProtectedRoute() {
  const location = useLocation();
  const { token, isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return <RouteFallback />;
  }

  if (!isAuthenticated || !token) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  try {
    const decoded = jwtDecode<DecodedToken>(token);

    if (decoded.role === "ADMIN" || decoded.role === "SUB_ADMIN") {
      return <Navigate to="/admin/companies" replace />;
    }

    if (decoded.role === "FACILITATOR") {
      return <Navigate to="/facilitator/dashboard" replace />;
    }

    if (isCompanyAppPortalRole(decoded.role)) {
      return <Navigate to="/home" replace />;
    }

    if (decoded.role === "EXPO_HEAD") {
      return <Navigate to="/expo-head/dashboard" replace />;
    }

    if (decoded.role === "EXPERT") {
      return <Navigate to="/expert/dashboard" replace />;
    }

    if (!isClusterPortalRole(decoded.role)) {
      invalidateClientSession();
      return <Navigate to="/login" state={{ from: location }} replace />;
    }

    return <Outlet />;
  } catch {
    invalidateClientSession();
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
}
